import firebase from "firebase/app";

import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";

var config = ''
if (process.env.NODE_ENV !== 'production') {
  //testing and development
  console.log('loaded ' + process.env.NODE_ENV)
  config = {
    apiKey: "AIzaSyBqPgMMiIddHhApbLMnQgXgKMW9O7zcnuY",
    authDomain: "tropicanaaman-6a403.firebaseapp.com",
    projectId: "tropicanaaman-6a403",
    storageBucket: "tropicanaaman-6a403.appspot.com",
    messagingSenderId: "274335088532",
    appId: "1:274335088532:web:630c9f4af0c4e6703a9981"
  };

} else {
  //production
  console.log('loaded ' + process.env.NODE_ENV)
  config = {
    apiKey: "AIzaSyBqPgMMiIddHhApbLMnQgXgKMW9O7zcnuY",
    authDomain: "tropicanaaman-6a403.firebaseapp.com",
    projectId: "tropicanaaman-6a403",
    storageBucket: "tropicanaaman-6a403.appspot.com",
    messagingSenderId: "274335088532",
    appId: "1:274335088532:web:630c9f4af0c4e6703a9981"
  };
}

const app = firebase.initializeApp(config);
const db = firebase.firestore(app);
const auth = firebase.auth();
const storr = firebase.storage();
const fb = firebase;
// const settings = {/* your settings... */ timestampsInSnapshots: true };
// db.settings(settings);

export {
  auth,
  db,
  storr,
  app,
  fb
};




// WEBPACK FOOTER //
// ./src/firebase/firebase.js